if (process.env.NODE_ENV === 'development') {
  require('dotenv').config()
}

var Environment = {
  API_URL: process.env.REACT_APP_API_URL,
  API_VERSION: process.env.REACT_APP_API_VERSION,
  TITLE_SITE_NAME: 'TainData Panorama',
  SEGMENT: process.env.REACT_APP_SEGMENT,
}

module.exports = Environment



// WEBPACK FOOTER //
// ./src/utils/environment.js